<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Identificação do profissional"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="form.usuario.nome"
                        disabled
                        label="Nome"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :mask="mask.cpf"
                        :value="form.usuario.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <FormBusca
            :form="form.busca"
            :model="model.busca"
            :usuario-id="id"
            @cleaned="jornadas = $event; isEspecialidadeConectasusCidadao = false"
            @searched="handleSearched"
            ref="FormBusca"
        />

        <FormAtribuicao
            :form="form.atribuicao"
            :id="id"
            :jornadas="jornadas"
            :model="model.atribuicao"
            :usuario-id="id"
            @updated="$refs.FormBusca.search()"
        />

        <ListBusca
            :is-especialidade-conectasus-cidadao="isEspecialidadeConectasusCidadao"
            :jornadas="jornadas"
            :usuario-id="id"
            @updated="$refs.FormBusca.search()"
        />
    </div>
</template>

<script>
// Components.
import FormAtribuicao from './components/atribuicao/Form'
import FormBusca from './components/busca/Form'
import ListBusca from './components/busca/List'

// Mixins.
import {error, mask, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        FormAtribuicao,
        FormBusca,
        ListBusca,
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('ambulatorio.jornada'),
        }
    },
    data: () => ({
        form: null,
        isEspecialidadeConectasusCidadao: false,
        jornadas: [],
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSearched(jornadas, isConectasus) {
            this.jornadas = jornadas
            this.isEspecialidadeConectasusCidadao = isConectasus
        },
        load() {
            const request = {
                origem: 'busca',
                usuarioId: this.id,
            }

            this.setLoading()

            this.repositories.jornada.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, mask, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: [Number, String], required: true},
    },
}
</script>